export default __webpack_public_path__ + "static/devices-set-2-20634aa30c6d4d33d6e7d28003f7a8c6.png";